import get from 'lodash/get';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import * as actions from 'actions/reviewsActions/imageReviewsActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
export default function imageReviewsReducer(state = {}, action) {
    switch (action.type) {
        case actions.ImageReviewActions.REQUEST:
            return Object.assign(Object.assign({}, state), { [action.imageId]: {
                    asyncStatus: AsyncStatus.LOADING
                } });
        case actions.ImageReviewActions.SUCCESS:
            const slots = get(action, 'data.slots');
            if (!slots)
                return state;
            const imageFullScreenWidget = slots.find((slot) => !!slot.widget && slot.widget.type === WidgetTypeV4.IMAGE_FULLSCREEN_WIDGET);
            return Object.assign(Object.assign({}, state), { [action.imageId]: {
                    asyncStatus: AsyncStatus.SUCCESS,
                    productReview: get(imageFullScreenWidget, 'widget.data.ugcProductReviewValueRenderableComponent'),
                    reviewImage: get(imageFullScreenWidget, 'widget.data.ugcReviewImageValueRenderableComponent'),
                    timestamp: Date.now()
                } });
        case actions.ImageReviewActions.ERROR:
            return Object.assign(Object.assign({}, state), { [action.imageId]: {
                    asyncStatus: AsyncStatus.ERROR
                } });
        default:
            return state;
    }
}
